<template>
  <div>
    <Spin fix class="ivu-spin-fullscreen" :class="{'dt-none': isLoading === false }">
      <Icon type="load-c" size="18" class="demo-spin-icon-load"></Icon>
      <div>{{loadingText}}</div>
    </Spin>
    <CreateDate
      v-show="!isShowMap"
      :userId="userId"
      :createDateInfo="createDateInfo"
      @readyCreateDate="createDateToServer"
      @closeCreateDate="createDailyInfo()"
    ></CreateDate>
    <div class="map-layout" v-show="isShowMap">
      <header class="map-layout-title">
        <span class="pull-left">走访日程</span>
        <!-- <span class='pull-right create-schedule' @click='createDailyInfo'>
            <Icon type="android-clipboard"></Icon>
            创建日程
        </span>-->
      </header>
      <div :class="{'with-all-8': !isShowLeftList}" class="left" ref="mapPanel">
        <div class="timeline-title">
          <span class="current-date">{{today}}</span>
          <span class="client-number">
            走访客户数
            <span class="number">{{personNum}}</span>
          </span>
          <span class="journey">
            预计行程
            <span class="journey-number">{{totalKm}}</span>
          </span>
          <Button class="show_button" @click="isOpenLeftList">{{tableShow}}</Button>

          <DatePicker
            v-if="showRevise"
            class="show_button"
            :open="showSelectDate"
            :value="toData"
            placement="bottom"
            confirm
            type="date"
            @on-change="handleChange"
            @on-clear="handleClear"
            @on-ok="handleOk"
          >
            <Button @click="handleClick">PJP调整</Button>
          </DatePicker>
        </div>
        <div id="mapContainer"></div>
      </div>
      <div class="right" v-show="isShowLeftList">
        <div id="calendar"></div>
        <div class="visit-panel">
          <div class="select-user-panel">
            <div class="select-user-block">
              <span class="select-user-title">城市</span>
              <Select
                :key="currentCity"
                v-model="currentCity"
                class="select-user text-center"
                @on-change="changeCity(currentCity)"
              >
                <Option v-for="city in cities" :key="city" :value="city">{{ city }}</Option>
              </Select>
            </div>
            <div class="select-user-block">
              <span class="select-user-title">业务员</span>
              <Select
                :key="currentUser.uuid"
                v-model="currentUser.uuid"
                class="select-user text-center"
                @on-change="changeUser(currentUser.uuid)"
              >
                <Option
                  v-for="user in userOptions"
                  :key="user.uuid"
                  :value="user.uuid"
                >{{ user.nickname }}</Option>
              </Select>
            </div>
          </div>
          <div class="current-month-num">
            <p class="title">本月业务量</p>
            <div class="current-month-num-body">
              <Col span="12">
                拜访用户数量
                <span>{{currentMonthPersion}}</span>
              </Col>
              <Col span="12">
                总行程
                <span>{{currentMonthMileage}}</span>
              </Col>
            </div>
          </div>
          <div class="future-visit-panel">
            <p class="title">未排入本月PJP的客户（{{futureVisit.length}}）</p>
            <div class="future-visit-panel-body">
              <div class="visit-item" v-for="visit in futureVisit">
                <Col span="12" class="visit-custorm">{{visit.attrs.CustomerName}}</Col>
                <Col span="12" class="add-daily" style="text-align:right;">
                  <span>+</span>
                  加入日程
                </Col>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import CreateDate from "./CreateDate.vue";
import "../assets/stylesheets/map.scss";
import "../assets/stylesheets/calendar.css";
import "../assets/javascript/jquery.min.js";
import "../assets/javascript/calendal.js";
import api from "../service/api";
import getData from "../service/getData";
import { setTimeout } from "timers";
import io from "socket.io-client";
import config from "../../config/config.js";
import moment from "moment";

let osmurl =
  "https://webrd04.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}";
// "http://map.geoq.cn/ArcGIS/rest/services/ChinaOnlineStreetGray/MapServer/tile/{z}/{y}/{x}";

export default {
  data() {
    return {
      timeFields: (function() {
        const fields = [];
        for (let i = 0; i < 24; i++) {
          fields.push(`${_.padStart(i.toString(), 2, "0")}:00`);
        }
        return fields;
      })(),
      today: "",
      personNum: 0,
      totalKm: "0km",
      dailyInfos: [],
      layerGroup: new L.layerGroup(),
      users: [],
      currentCity: null,
      userId: sessionStorage.getItem("userId"), //线上
      userRole: sessionStorage.getItem("role"),
      userRoleCode: sessionStorage.getItem("roleCode"),
      type: sessionStorage.getItem("type"),
      region: sessionStorage.getItem("region"),
      // userId: "e4ad53c0-1d25-11e8-8c16-65f92941997a",//线上
      // userId: "aa9447c1-1d25-11e8-b4dd-7d165e3ab3c5",//本地
      currentUser: {},
      currentMonth: moment().format("YYYYMM"),
      currentMonthPersion: 0,
      currentMonthMileage: 0,
      isShowMap: true,
      futureVisit: [],
      createDateInfo: {
        vehicle_type: "3",
        max_distance: 1,
        max_visits: 18,
        min_visits: 10,
        speed_adjustment: 0,
        holiday: {}
      },
      isLoading: false,
      loadingText: "加载中...",
      dates: null,
      isShowLeftList: true,
      tableShow: "隐藏",
      showSelectDate: false,
      showRevise: true,
      toData: ""
    };
  },
  computed: {
    userOptions() {
      if (this.currentCity) {
        return _.filter(
          this.users,
          user => user.info.City === this.currentCity
        );
      } else {
        return this.users;
      }
    },
    cities() {
      return _.uniq(_.map(this.users, user => user.info.City));
    }
  },
  mounted() {
    //初始化地图
    this.map = L.map("mapContainer", {
      center: [31.120049, 121.30765],
      zoom: 10,
      minZoom: 1,
      maxZoom: 18,
      projection: L.Projection.LonLat,
      attributionControl: false,
      zoomControl: false
    });
    L.tileLayer(osmurl).addTo(this.map);
    L.control
      .zoom({
        position: "bottomright",
        zoomInTitle: "放大",
        zoomOutTitle: "缩小"
      })
      .addTo(this.map);
    L.control
      .scale({
        imperial: false
      })
      .addTo(this.map);
    this.layerGroup.addTo(this.map);
    this.getScheduUsers();
    const self = this;
    const socket = io(config.SOCKET_URL);
    socket.on("connect", function() {
      console.log("connect");
    });
    socket.on("planStart", function(data) {
      if (data && data.userId === self.userId) {
        console.log("planStart", data);
      }
    });
    socket.on("planComplete", function(data) {
      if (data && data.userId === self.userId) {
        console.log("planComplete", data);
        self.closeLoading();
        self.getAllDates();
      }
    });
    socket.on("planFailed", function(data) {
      if (data && data.userId === self.userId) {
        console.log("planFailed", data);
        self.$Message.error("规划线路失败");
        self.closeLoading();
      }
    });
    socket.on("disconnect", function() {
      console.log("disconnect");
    });
    this.controlRevise();
  },
  components: {
    CreateDate
  },
  methods: {
    controlRevise: function() {
      const now = moment(); //当前时间
      const lastDay = moment().endOf("month");
      const last2Day = lastDay.subtract(1, "days"); //每月倒数第2天23:59:59
      const start25Day = moment()
        .startOf("month")
        .add(25, "day"); //每月26号，00:00:00

      const startDay = now.diff(start25Day);
      const endDay = last2Day.diff(now);
      if (startDay > 0 && endDay > 0) {
        //都大于0，说明在区间内
        //显示
        this.showRevise = true;
      } else {
        //隐藏
        this.showRevise = false;
      }
    },
    changeCity: function(city) {
      if (this.userOptions[0]) {
        this.changeUser(this.userOptions[0].uuid);
      }
    },
    changeUser: function(uuid, getDate) {
      if (!this.isShowMap) {
        this.reloadCreateDateInfo();
      }
      for (let i = 0; i < this.users.length; i++) {
        let user = this.users[i];
        if (user.uuid === uuid) {
          this.currentUser = user;
          this.userId = user.uuid;
          this.getAllDates(getDate ? getDate : undefined);
        }
      }
    },
    reloadCreateDateInfo: function() {
      this.createDateInfo = {
        vehicle_type: "3",
        max_distance: 1,
        max_visits: 18,
        min_visits: 10,
        speed_adjustment: 0,
        holiday: {}
      };
    },
    createDateToServer: async function(data) {
      this.openLoading("准备规划中...");
      const res = await getData.post(api.createDate, data);
      if (res && res.data && res.data.status) {
        this.loadingText = `${res.data.msg}...`;
      }
    },
    getCreateDateOption: async function() {
      let params = {
        user_id: this.userId
      };
      this.openLoading("获取数据中...");
      const res = await getData.get(api.createDateOption, params);
      if (res && res.data && res.data.status) {
        // this.createDateInfo = res.data.option;
        this.createDateInfo = Object.assign(
          this.createDateInfo,
          res.data.option
        );
        // console.log(this.createDateInfo);
        this.isShowMap = !this.isShowMap;
        this.closeLoading();
      }
    },
    createDailyInfo: function() {
      if (this.isShowMap) {
        this.getCreateDateOption();
      } else {
        this.createDataControl(this.dates);
        this.isShowMap = !this.isShowMap;
      }
    },
    isOpenLeftList() {
      this.isShowLeftList = !this.isShowLeftList;
      if (this.tableShow === "隐藏") {
        this.tableShow = "展示";
      } else {
        this.tableShow = "隐藏";
      }
      let self = this;
      setTimeout(function() {
        self.map.invalidateSize(true, { debounceMoveend: true });
      }, 100);
    },
    openLoading: function(text) {
      this.isLoading = !this.isLoading;
      this.loadingText = text;
    },
    closeLoading: function() {
      let self = this;
      setTimeout(function() {
        self.isLoading = !self.isLoading;
      }, 500);
    },
    refreshAll: function() {
      // this.today = null;
      this.personNum = 0;
      this.totalKm = "0km";
      this.dailyInfos = [];
      this.layerGroup.clearLayers();
      // this.users = [];
      this.currentMonthPersion = 0;
      this.currentMonthMileage = 0;
      this.isShowMap = true;
      this.futureVisit = [];
    },
    getScheduUsers: async function() {
      //获取有控制权限的人员
      this.refreshAll();
      let self = this;
      let params = {
        user_id: this.userId,
        type: this.type,
        user_role: this.userRole,
        user_role_code: this.userRoleCode,
        region: this.region
      };
      const res = await getData.get(api.schedueUsers, params);
      if (res && res.data && res.data.status) {
        $("#calendar").empty();
        self.users = res.data.users;
        if (!self.currentCity) {
          self.currentCity = self.cities[0];
        }
        if (res.data.currentUser) {
          self.currentUser = res.data.currentUser;
          this.userId = res.data.currentUser.uuid;
          this.getAllDates();
        }
      } else {
        this.$Message.error(res);
      }
    },
    getAllDates: async function(date) {
      //如果有日期，说明得到的是指定日期数据不是当前日期的
      this.refreshAll();
      let self = this;
      const startDate = moment(this.currentMonth, "YYYYMM")
        .startOf("month")
        .format("YYYY-MM-DD");
      const endDate = moment(this.currentMonth, "YYYY-MM")
        .endOf("month")
        .format("YYYY-MM-DD");
      let params = {
        user_id: this.userId,
        startDate,
        endDate
      };
      const res = await getData.get(api.allDates, params);
      if (res && res.data && res.data.status) {
        $("#calendar").empty();
        // self.users = res.data.users;
        if (res.data.currentUser) {
          self.currentUser = res.data.currentUser;
        }
        self.futureVisit = res.data.unPlanOrders;
        self.dates = res.data.dates;
        self.createDataControl(self.dates, date);
      } else {
        this.$Message.error(res);
      }
    },
    createDailyInfos: function(dates, color) {
      this.dailyInfos = [];
      let timeLine = 0;
      let isLeft = false;
      let left = 0;
      let firstTop = 0;
      for (let i = 0; i < dates.length; i++) {
        let dailyInfo = dates[i];
        if (!dailyInfo || !dailyInfo.attrs) {
          continue;
        }
        let hours = parseInt(dailyInfo.time.split(":")[0]);
        let minutes = parseInt(dailyInfo.time.split(":")[1]);
        let offset = 22; //偏移22个像素的高度
        let top = hours * 60 + minutes + offset;
        if (firstTop === 0) {
          firstTop = top;
        }
        let height = parseInt(dailyInfo.leaveTime.split(":")[1]) - minutes;
        if (height < 20) {
          height = 20;
        }
        if (timeLine === 0) {
          timeLine = hours.toString();
        } else if (timeLine.indexOf(hours) > -1) {
          isLeft = true;
          left += 168;
        } else {
          timeLine = hours.toString();
          isLeft = false;
          left = 0;
        }
        let diff = (height - 20) / 2 + top;
        if (isLeft) {
          dailyInfo.style = `top:${top}px;height:${height}px;line-height:${height}px;left:${left}px`;
          dailyInfo.spanStyle = `top:${diff}px;height:20px;line-height:20px;left:${left}px`;
        } else {
          dailyInfo.style = `top:${top}px;height:${height}px;line-height:${height}px`;
          dailyInfo.spanStyle = `top:${diff}px;height:20px;line-height:20px`;
        }
        let latlng = L.latLng([
          dailyInfo.attrs.Latitude,
          dailyInfo.attrs.Longitude
        ]);
        dailyInfo.name = dailyInfo.attrs.CustomerName;

        let way_point_dom = `<div class='way-points' style='background-color:
        ${dailyInfo.attrs.OTMClass === "P" ? "#ff0000" : color};'>${i +
          1}</div>`;
        let wayDivIcon = new L.divIcon({
          html: way_point_dom,
          className: "leaflet-direction-icon"
        });
        dailyInfo.marker = new L.Marker(latlng, {
          icon: wayDivIcon,
          zIndexOffset: 1
        });
        dailyInfo.marker.bindTooltip(dailyInfo.name);
        this.dailyInfos.push(dailyInfo);
        this.layerGroup.addLayer(dailyInfo.marker);
      }
      $(".timeline-body").scrollTop(firstTop - 20);
      firstTop = 0;
      this.closeLoading();
    },
    getDayInfo: async function(date) {
      if (this.userId === "admin") {
        return;
      }
      let self = this;
      let params = {
        user_id: this.userId,
        date: date
      };
      this.openLoading("加载中...");
      const res = await getData.get(api.dayinfo, params);
      if (res && res.data && res.data.status && res.data.dailyInfo) {
        this.layerGroup.clearLayers();
        let planData = res.data.dailyInfo.planData;
        self.personNum = planData.reachTimes.length;
        self.totalKm = `${Math.max(
          parseInt(planData.route.distance / 1000),
          1
        )}km`;
        let color = "#0095ff";
        // color = this.randomColor();
        let path = planData.route.path;
        let line = L.polyline(path, { color });
        this.layerGroup.addLayer(line);
        this.fitBounds(planData.reachTimes);
        let dates = planData.reachTimes;
        if (dates && dates.length !== 0) {
          self.createDailyInfos(dates, color);
        }
      } else {
        self.closeLoading();
        let errorMsg = "服务器错误";
        if (res && res.data && res.data.msg) {
          errorMsg = res.data.msg;
        }
        self.$Message.error(errorMsg);
      }
    },
    randomColor() {
      return `#${(0x1000000 + Math.random() * 0xffffff)
        .toString(16)
        .substr(1, 6)}`;
    },
    createDataControl(dates, getDate) {
      //data有的时候就用这个日期
      let self = this;
      $("#calendar").calendar({
        ifSwitch: true, // 是否切换月份
        hoverDate: false, // hover是否显示当天信息
        backToday: false, // 是否返回当天
        selected_data: self.today.replace(/-/g, ""),
        dates: dates,
        afterInit: function(today) {
          if (today) {
            self.today = today;
          }
          if (!self.currentMonth)
            self.currentMonth = moment(today).format("YYYYMM");
          self.computeMonthInfo(self.currentMonth);
          self.getDayInfo(getDate ? getDate : self.today);
        },
        onMonthChange: function(date) {
          const monthString = moment(date).format("YYYYMM");
          self.currentMonth = monthString;
          self.getAllDates();
          // self.computeMonthInfo(monthString);
        },
        onClick: function(today, selectDay) {
          self.today = selectDay;
          self.getDayInfo(selectDay);
        }
      });
    },
    computeMonthInfo(monthString) {
      // const year = theDate.getFullYear();
      // const month = _.padStart(theDate.getMonth() + 1, 2, "0");
      // const monthString = `${year}${month}`;
      let _monthPersion = 0;
      let _monthMileage = 0;

      for (let date in this.dates) {
        if (_.startsWith(date, monthString)) {
          _monthPersion += this.dates[date].orderCounts;
          _monthMileage += this.dates[date].distance || 0;
        }
      }
      this.currentMonthPersion = _monthPersion;
      this.currentMonthMileage = `${parseInt(_monthMileage / 1000)}Km`;
    },
    hoverOrder: function(dailyInfo, number) {
      this.map.openPopup(
        `${number}: ${dailyInfo.name}`,
        dailyInfo.marker.getLatLng(),
        { closeButton: false }
      );
    },
    leaveOrder: function() {
      this.map.closePopup();
    },
    //TODO 获取需要排序的点，测试用
    // getPoint: function (points, resource) {
    //   const geoPoints = [];
    //   for (let point of points) {
    //     geoPoints.push(point.point);
    //   }

    //   const geojsonLayer = L.geoJSON(geoPoints, {
    //     style: function (feature) {
    //       return { color: "#f00" };
    //     }
    //   }).addTo(this.map);
    //   this.map.fitBounds(geojsonLayer.getBounds());

    //   L.circleMarker(resource, {
    //     //resource位置
    //     radius: 5,
    //     color: "red"
    //   }).addTo(this.map);
    // },
    fitBounds(reachTimes) {
      let points = [];
      reachTimes.forEach(item => {
        if (item && item.attrs) {
          points.push([item.attrs.Latitude, item.attrs.Longitude]);
        }
      });
      if (points.length > 0) {
        this.map.fitBounds(points);
      }
    },
    //移动到的日期选项
    handleClick() {
      this.showSelectDate = !this.showSelectDate;
    },
    handleChange(date) {
      this.toData = date;
      console.log(this.today);
    },
    handleClear() {
      this.showSelectDate = false;
    },
    handleOk() {
      this.showSelectDate = false;
      this.update();
    },
    async update() {
      //发送更改日期请求
      if (this.today === this.toData) {
        this.$Message.info({
          content: "更改日期与当前日期不能相同",
          duration: 5
        });
        return;
      }

      const currMoment = moment(this.today);
      const newMoment = moment(this.toData);
      const lastDay = moment().endOf("month");

      const aa = lastDay.diff(currMoment);
      const bb = lastDay.diff(newMoment);
      if (aa > 0 || bb > 0) {
        //有一个在当月最后一天之前都不行
        this.$Message.info({
          content: "只能规划下月数据",
          duration: 5
        });
        return;
      }

      let params = {
        user_id: this.userId,
        currentDate: this.today,
        newDate: this.toData
      };
      const res = await getData.put(api.putDayinfo, params);
      if (res.data && res.data.status) {
        this.changeUser(this.userId, this.today); //重新刷新人员数据
      } else if (res.data) {
        this.$Message.info({
          content: res.data.msg,
          duration: 5
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.map-layout .with-all-8 {
  width: calc(~"100% - 8px");
}
.show_button {
  float: right;
  margin-top: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Map.vue